export default () => ({
  charts: {
    paddingBottom: 2,
    marginBottom: 34,
  },
});



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Charts/styles.js